import styled from 'styled-components';

export const SizeUnitsItemStyled = styled.span`
  text-decoration: ${props => (props.$selected ? 'underline' : 'none')};
`;
